import React, { useState } from "react";
import "./ExpenseForm.css";
import { addDoc } from "@firebase/firestore";
import db from "../../firebase-config";

const ExpenseForm = (props) => {
  const [enteredTitle, setEnteredTitle] = useState("");
  const [enteredAmount, setEnteredAmount] = useState("");
  const [enteredDate, setEnteredDate] = useState("");
  const [buttonState, setButtonState] = useState(false);

  const titleChangeHandler = (event) => {
    setEnteredTitle(event.target.value);
  };

  const amountChangeHandler = (event) => {
    setEnteredAmount(event.target.value);
  };

  const dateChangeHandler = (event) => {
    setEnteredDate(event.target.value);
  };

  const submitHandler = async (event) => {
    event.preventDefault();

    const expenseData = {
      title: enteredTitle,
      amount: +enteredAmount,
      date: new Date(enteredDate),
    };

    await addDoc(db, expenseData);

    // props.onSaveExpenseData(expenseData);
     setEnteredTitle("");
     setEnteredAmount("");
     setEnteredDate("");
  };

  const buttonClickHandler = () => {
    if (buttonState === true) {
      setButtonState(false);
    } else setButtonState(true);
  };

  let cancelButton = (
    <div className="new-expense__actions">
      <button type="button" onClick={buttonClickHandler}>
        Cancel
      </button>
    </div>
  );

  let fullForm = (
    <form onSubmit={submitHandler}>
      <div className="new-expense__controls">
        <div className="new-expense__control">
          <label>Title</label>
          <input
            type="text"
            value={enteredTitle}
            onChange={titleChangeHandler}
          />
        </div>
        <div className="new-expense__control">
          <label>Amount</label>
          <input
            type="number"
            min="0.01"
            step="0.01"
            value={enteredAmount}
            onChange={amountChangeHandler}
          />
        </div>
        <div className="new-expense__control">
          <label>Date</label>
          <input
            type="date"
            min="2019-01-01"
            max="2022-12-31"
            value={enteredDate}
            onChange={dateChangeHandler}
          />
        </div>
        <div className="new-expense__actions">
          <button type="submit">Add Expense</button>
        </div>
        {cancelButton}
      </div>
    </form>
  );

  let form = (
    <form>
      <div className="new-expense__controls">
        <div className="new-expense__actions">
          <button type="button" onClick={buttonClickHandler}>
            Add New Expense
          </button>
        </div>
      </div>
    </form>
  );

  if (buttonState === true) {
    return fullForm;
  }
  else return form;
};

export default ExpenseForm;
